const build = `module stripe.com/docs/payments/checkout

go 1.13

require github.com/stripe/stripe-go/v72 v72.60.0
`;

export default {
  build,
};
